import { render, staticRenderFns } from "./Tele2TelephoneInput.vue?vue&type=template&id=1204e0f0&scoped=true&"
import script from "./Tele2TelephoneInput.vue?vue&type=script&lang=js&"
export * from "./Tele2TelephoneInput.vue?vue&type=script&lang=js&"
import style0 from "./Tele2TelephoneInput.vue?vue&type=style&index=0&id=1204e0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204e0f0",
  null
  
)

export default component.exports